import { SET_FILTERS } from '../actions';

export function setFilters(payload) {
    return {
        type: SET_FILTERS,
        payload
    }
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/filters.js